/**
 * Typesense-powered PRODUCTS-ONLY search results page for the Maximize theme.
 */
(function () {
  "use strict";

  var DEFAULT_IMAGE = "https://cdn.shopify.com/s/files/1/0799/6928/8436/files/placeholder-image_430x.png";
  var isRtl = false;

  var FACET_FIELDS = {
    vendor: { en: "vendor_name_en", ar: "vendor_name_ar" },
    collection: { en: "collections_en", ar: "collections_ar" },
  };

  var client = null;
  function getClient(cfg) {
    if (!client) {
      client = new Typesense.Client({
        nodes: [{ host: cfg.host, port: cfg.port, protocol: cfg.protocol }],
        apiKey: cfg.apiKey,
        connectionTimeoutSeconds: 2,
      });
    }
    return client;
  }

  function localizedUrl(path, isArabic) {
    if (!isArabic) return path;
    if (path.indexOf("/ar/") === 0 || path === "/ar") return path;
    return "/ar" + path;
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str == null ? "" : String(str);
    return div.innerHTML;
  }

  function jsStringEscape(str) {
    return String(str == null ? "" : str).replace(/\\/g, "\\\\").replace(/'/g, "\\'");
  }

  function formatMoney(cfg, amount, currencyText) {
    var value = Number(amount || 0).toFixed(2);
    // Currency after number for Arabic/RTL
    if (isRtl) {
      return value + " " + currencyText;
    }
    // Currency before number for English/LTR
    return currencyText + " " + value;
  }

  function filterLiteral(value) {
    return "`" + String(value).replace(/`/g, "") + "`";
  }

  // Turns a handleized tag ("tara-weight-function") into a human-readable
  // label ("Tara Weight Function") for display in the active-filter chips.
  function humanizeTagHandle(handle) {
    return String(handle)
      .split("-")
      .filter(Boolean)
      .map(function (w) {
        return w.charAt(0).toUpperCase() + w.slice(1);
      })
      .join(" ");
  }

  var HIDDEN_COLLECTION_EXACT = ["all offers", "all products"];
  var HIDDEN_COLLECTION_SUBSTRINGS = ["in sale", "in stock"];
  function isHiddenCollectionValue(value) {
    if (!value) return false;
    var v = String(value).trim().toLowerCase();
    if (HIDDEN_COLLECTION_EXACT.indexOf(v) !== -1) return true;
    if (v.indexOf("-") !== -1) return true;
    for (var i = 0; i < HIDDEN_COLLECTION_SUBSTRINGS.length; i++) {
      if (v.indexOf(HIDDEN_COLLECTION_SUBSTRINGS[i]) !== -1) return true;
    }
    return false;
  }

  var FACET_VISIBLE_LIMIT = 6;

  function isBogoOfferValue(value) {
    return /^b\d+g\d+$/i.test(String(value).trim());
  }

  function formatOfferPillLabel(value) {
    var raw = String(value).trim().toLowerCase();
    var bogoMatch = raw.match(/^b(\d+)g(\d+)$/);
    if (bogoMatch) return bogoMatch[1] + " + " + bogoMatch[2];
    var numeric = raw.replace("%", "");
    if (/^\d+(\.\d+)?$/.test(numeric)) return numeric + "%";
    return value;
  }

  function offerDiscountWeight(value) {
    var raw = String(value).trim().toLowerCase();
    var bogoMatch = raw.match(/^b(\d+)g(\d+)$/);
    if (bogoMatch) {
      var buy = parseInt(bogoMatch[1], 10);
      var get = parseInt(bogoMatch[2], 10);
      return (get / (buy + get)) * 100;
    }
    var numeric = raw.replace("%", "");
    if (/^\d+(\.\d+)?$/.test(numeric)) return parseFloat(numeric);
    return -1;
  }

  function productIdFromGid(gid) {
    if (!gid) return "";
    var parts = String(gid).split("/");
    return parts[parts.length - 1];
  }

  var iconCache = {};
  function getIconHtml(templateId) {
    if (iconCache[templateId] !== undefined) return iconCache[templateId];
    var el = document.getElementById(templateId);
    var html = el ? el.innerHTML : "";
    iconCache[templateId] = html;
    return html;
  }

  // Returns a percentage-off badge string (e.g. "-25%") when compare_at_price
  // implies a discount that isn't already covered by offer_type/offer_badge,
  // so it can be passed straight into the top-left corner badge. Mirrors
  // assets/ts-search.js's computeCompareAtBadge exactly, so the header
  // dropdown and the full results page agree on when a product counts as
  // "on sale via compare-at-price" vs. an explicit offer_type.
  function computeCompareAtBadge(doc) {
    var price = Number(doc.price || 0);
    var compareAtPrice = Number(doc.compare_at_price || 0);
    if (compareAtPrice > price && compareAtPrice > 0) {
      var pct = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
      return "-" + pct + "%";
    }
    return "";
  }

  // Animated "MEGA SALE" ribbon shown alongside the price whenever the
  // discount comes from compare_at_price rather than an explicit
  // sale_price/on_sale flag. Ported verbatim from assets/ts-search.js
  // (renderMegaSaleBadge) so the header dropdown and the full results page
  // render an identical badge -- the SVG carries its own width/height, so
  // it doesn't need any matching CSS added to main-search.liquid; it relies
  // on the theme's existing .mega-sale-badge-cart styling (if any) the same
  // way the header dropdown does.
  function renderMegaSaleBadge(doc, isArabic) {
    var badgeText = isArabic ? "تخفيضات كبرى" : "MEGA SALE";
    var uniqueId = (doc && doc.id ? doc.id : Math.random().toString(36).slice(2)) + "-ts-card";

    return (
      '<div class="mega-sale-badge-cart mb-2" aria-label="' + escapeHtml(badgeText) + '">' +
      '<svg width="100" height="32" viewBox="0 0 100 32" xmlns="http://www.w3.org/2000/svg" role="img" preserveAspectRatio="none">' +
        "<defs>" +
          '<linearGradient id="fireGrad-' + uniqueId + '" x1="0%" y1="100%" x2="0%" y2="0%">' +
            '<stop offset="0%" stop-color="#FF8C00">' +
              '<animate attributeName="stop-color" values="#FF8C00;#FF6A00;#FF8C00" dur="3s" repeatCount="indefinite"/>' +
            "</stop>" +
            '<stop offset="50%" stop-color="#FF4500">' +
              '<animate attributeName="stop-color" values="#FF4500;#FF2200;#FF4500" dur="2s" repeatCount="indefinite"/>' +
            "</stop>" +
            '<stop offset="100%" stop-color="#D30F2F">' +
              '<animate attributeName="stop-color" values="#D30F2F;#FF3D3D;#D30F2F" dur="4s" repeatCount="indefinite"/>' +
            "</stop>" +
          "</linearGradient>" +
          '<filter id="glow-' + uniqueId + '">' +
            '<feGaussianBlur stdDeviation="2.5" result="blur"/>' +
            "<feMerge>" +
              '<feMergeNode in="blur"/>' +
              '<feMergeNode in="SourceGraphic"/>' +
            "</feMerge>" +
          "</filter>" +
        "</defs>" +

        '<rect width="100" height="32" rx="6" fill="url(#fireGrad-' + uniqueId + ')"/>' +

        '<path d="M8 32C12 12 20 16 18 2C24 8 32 6 30 32H8Z" fill="#FFD700" opacity="0.35" filter="url(#glow-' + uniqueId + ')">' +
          '<animateTransform attributeName="transform" type="translate" values="0 1;0 -2;0 1" dur="1.4s" repeatCount="indefinite"/>' +
        "</path>" +

        '<path d="M15 32C18 16 22 16 21 6C25 10 28 9 27 32H15Z" fill="#FFF3B0" opacity="0.65">' +
          '<animateTransform attributeName="transform" type="translate" values="0 1;0 -1;0 1" dur="1s" repeatCount="indefinite"/>' +
        "</path>" +

        '<path d="M60 32C66 10 76 14 72 0C80 7 88 5 86 32H60Z" fill="#FFD700" opacity="0.30" filter="url(#glow-' + uniqueId + ')">' +
          '<animateTransform attributeName="transform" type="translate" values="0 1;0 -3;0 1" dur="1.6s" repeatCount="indefinite"/>' +
        "</path>" +

        '<path d="M68 32C72 15 76 15 75 5C80 10 83 8 82 32H68Z" fill="#FFF3B0" opacity="0.55">' +
          '<animateTransform attributeName="transform" type="translate" values="0 1;0 -2;0 1" dur="1.2s" repeatCount="indefinite"/>' +
        "</path>" +

        '<circle cx="24" cy="24" r="1.2" fill="#FFF3B0">' +
          '<animate attributeName="cy" values="24;8;24" dur="2.5s" repeatCount="indefinite"/>' +
          '<animate attributeName="opacity" values="0;1;0" dur="2.5s" repeatCount="indefinite"/>' +
        "</circle>" +

        '<circle cx="74" cy="26" r="1" fill="#FFF3B0">' +
          '<animate attributeName="cy" values="26;10;26" dur="3s" repeatCount="indefinite"/>' +
          '<animate attributeName="opacity" values="0;0.8;0" dur="3s" repeatCount="indefinite"/>' +
        "</circle>" +

        '<text x="50%" y="50%" dominant-baseline="central" text-anchor="middle" ' +
        'font-family="\'Outfit\', sans-serif" font-weight="900" font-size="' + (isArabic ? "11" : "12") + '" fill="#FFFFFF" ' +
        'letter-spacing="0.05em" style="text-transform:uppercase;text-shadow:1px 1px 4px rgba(0,0,0,0.65);">' +
          escapeHtml(badgeText) +
        "</text>" +
      "</svg>" +
      "</div>"
    );
  }

  // Price + compare-at markup, with the mega sale badge appended only when
  // the strike-through price came from compare_at_price (showMegaSaleBadge),
  // not from an explicit sale_price/on_sale flag -- mirrors
  // assets/ts-search.js's renderPriceMarkup/renderProductPrice split.
  function renderPriceMarkupCard(cfg, currentPrice, wasPrice, showMegaSaleBadge, doc, isArabic, currencyText) {
    var html =
      '<div class="product-card__price mb-1 h5 inline-flex items-center gap-2">' +
      '<span class="price">' + formatMoney(cfg, currentPrice, currencyText) + "</span>" +
      '<span class="text-[80%] compare-at-price line-through">' + formatMoney(cfg, wasPrice, currencyText) + "</span>" +
      "</div>";
    if (showMegaSaleBadge) {
      html += renderMegaSaleBadge(doc, isArabic);
    }
    return html;
  }

  document.addEventListener("alpine:init", function () {
    Alpine.data("xTypesenseSearchPage", function (sectionId, perPage, isRtlPage, currencyText) {
      // Set global RTL flag
      isRtl = !!isRtlPage;

      return {
        isLoading: false,
        isLoadingMore: false,
        hasMore: false,
        resultsCount: 0,
        page: 1,
        query: "",
        isArabic: isRtl,
        currencyText: currencyText || "SAR",
        sortBy: "relevance",
        selected: {
          vendor: [],
          collection: [],
          offer_type: [],
          tag: [],
          available: null,
          on_sale: null,
          prescribed: null,
        },
        priceMin: null,
        priceMax: null,
        priceBoundsMin: 0,
        priceBoundsMax: 1000,
        facetData: { vendor: [], collection: [], offer_type: [] },
        expandedFacets: { vendor: false, collection: false },
        productsHtml: "",
        isDesktop: false,
        listLayout: false,
        showFilterAside: true,
        isShow: false,
        _observer: null,

        init() {
          var cfg = window.TypesenseSearchConfig;
          if (!cfg) {
            console.error("Typesense search page: window.TypesenseSearchConfig missing.");
            return;
          }
          this._cfg = cfg;
          this._parseFromLocation();

          installMediaQueryWatcher("(min-width: 768px)", (matches) => {
            this.isDesktop = matches;
            if (matches) this._setBodyScrollLock(false);
          });

          this.$watch("isShow", (value) => {
            this._setBodyScrollLock(value && !this.isDesktop);
          });

          window.addEventListener("popstate", () => {
            this._parseFromLocation();
            this.runSearch(false);
          });

          this.runSearch(false);
        },

        _setBodyScrollLock(shouldLock) {
          document.documentElement.classList.toggle("ts-scroll-lock", !!shouldLock);
          document.body.style.overflow = shouldLock ? "hidden" : "";
        },

        _parseFromLocation() {
          var params = new URLSearchParams(window.location.search);
          var rawQ = params.get("q") || "";

          // /search?q=tag:<handle>[,<handle2>...] is a tag filter, not a
          // free-text query -- route it into selected.tag and leave
          // `query` empty so it isn't sent to Typesense as search text.
          var tagMatch = /^tag:(.+)$/i.exec(rawQ.trim());
          if (tagMatch) {
            this.query = "";
            this.selected.tag = tagMatch[1]
              .split(",")
              .map(function (t) {
                return t.trim();
              })
              .filter(Boolean);
          } else {
            this.query = rawQ;
            this.selected.tag = [];
          }

          this.sortBy = params.get("sort") || "relevance";
          this.page = parseInt(params.get("page") || "1", 10) || 1;
          this.selected.vendor = (params.get("vendor") || "").split(",").filter(Boolean);
          this.selected.collection = (params.get("collection") || "").split(",").filter(Boolean);
          this.selected.offer_type = (params.get("offer_type") || "").split(",").filter(Boolean);
          this.selected.available = params.has("available") ? params.get("available") === "true" : null;
          this.selected.on_sale = params.has("on_sale") ? params.get("on_sale") === "true" : null;
          this.selected.prescribed = params.has("prescribed") ? params.get("prescribed") === "true" : null;
          this.priceMin = params.has("price_min") ? Number(params.get("price_min")) : null;
          this.priceMax = params.has("price_max") ? Number(params.get("price_max")) : null;
        },

        _buildUrl(page) {
          var params = new URLSearchParams();
          if (this.query) {
            params.set("q", this.query);
          } else if (this.selected.tag.length) {
            params.set("q", "tag:" + this.selected.tag.join(","));
          }
          params.set("type", "product");
          if (this.sortBy !== "relevance") params.set("sort", this.sortBy);
          if (this.selected.vendor.length) params.set("vendor", this.selected.vendor.join(","));
          if (this.selected.collection.length) params.set("collection", this.selected.collection.join(","));
          if (this.selected.offer_type.length) params.set("offer_type", this.selected.offer_type.join(","));
          if (this.selected.available !== null) params.set("available", String(this.selected.available));
          if (this.selected.on_sale !== null) params.set("on_sale", String(this.selected.on_sale));
          if (this.selected.prescribed !== null) params.set("prescribed", String(this.selected.prescribed));
          if (this.priceMin !== null) params.set("price_min", String(this.priceMin));
          if (this.priceMax !== null) params.set("price_max", String(this.priceMax));
          params.set("page", String(page || this.page));
          return window.location.pathname + "?" + params.toString();
        },

        _updateUrl(push) {
          var url = this._buildUrl(this.page);
          if (push) {
            history.pushState({ url: url }, "", url);
          } else {
            history.replaceState({ url: url }, "", url);
          }
        },

        _facetField(group) {
          return FACET_FIELDS[group][this.isArabic ? "ar" : "en"];
        },

        _buildFilterBy(excludeGroup) {
          var parts = [];

          if (excludeGroup !== "tag" && this.selected.tag.length) {
            parts.push("tag_handles:=[" + this.selected.tag.map(filterLiteral).join(",") + "]");
          }
          if (excludeGroup !== "vendor" && this.selected.vendor.length) {
            parts.push(
              this._facetField("vendor") + ":=[" + this.selected.vendor.map(filterLiteral).join(",") + "]"
            );
          }
          if (excludeGroup !== "collection" && this.selected.collection.length) {
            parts.push(
              this._facetField("collection") + ":=[" + this.selected.collection.map(filterLiteral).join(",") + "]"
            );
          }
          if (excludeGroup !== "offer_type" && this.selected.offer_type.length) {
            parts.push("offer_type:=[" + this.selected.offer_type.map(filterLiteral).join(",") + "]");
          }
          if (excludeGroup !== "available" && this.selected.available !== null) {
            parts.push("available:" + this.selected.available);
          }
          if (excludeGroup !== "on_sale" && this.selected.on_sale !== null) {
            parts.push("on_sale:" + this.selected.on_sale);
          }
          if (excludeGroup !== "prescribed" && this.selected.prescribed !== null) {
            parts.push("is_prescribed:" + this.selected.prescribed);
          }
          if (excludeGroup !== "price" && (this.priceMin !== null || this.priceMax !== null)) {
            var lo = this.priceMin !== null ? this.priceMin : this.priceBoundsMin;
            var hi = this.priceMax !== null ? this.priceMax : this.priceBoundsMax;
            parts.push("price:[" + lo + ".." + hi + "]");
          }
          return parts.join(" && ");
        },

        /*_sortByParam() {
          switch (this.sortBy) {
            case "price_asc":
              return "price:asc";
            case "price_desc":
              return "price:desc";
            case "newest":
              return "updated_at:desc";
            default:
              return this.query ? "_text_match:desc,available:desc" : "updated_at:desc";
          }
        },*/
        /* out of stock always in the bottom */
        _sortByParam() {
          switch (this.sortBy) {
            case "price_asc":
              return "available:desc,price:asc";
            case "price_desc":
              return "available:desc,price:desc";
            case "newest":
              return "available:desc,updated_at:desc";
            default:
              return this.query ? "available:desc,_text_match:desc" : "available:desc,updated_at:desc";
          }
        },

        async runSearch(appendPage) {
          var cfg = this._cfg;
          if (!cfg) return;

          if (appendPage) {
            this.isLoadingMore = true;
          } else {
            this.isLoading = true;
            this.page = 1;
          }

          var queryByField = this.isArabic
            ? "name_ar,description_ar,vendor_name_ar,collections_ar,sku"
            : "name_en,description_en,vendor_name_en,collections_en,sku";

          var documents = getClient(cfg).collections(cfg.collection).documents();

          try {
            var mainSearchPromise = documents.search({
              q: this.query || "*",
              query_by: queryByField,
              query_by_weights: "4,1,3,2,5",
              filter_by: this._buildFilterBy(null) || undefined,
              sort_by: this._sortByParam(),
              page: this.page,
              per_page: perPage || 24,
            });

            var vendorFacetPromise = documents.search({
              q: this.query || "*",
              query_by: queryByField,
              filter_by: this._buildFilterBy("vendor") || undefined,
              facet_by: this._facetField("vendor"),
              max_facet_values: 20,
              per_page: 0,
            });
            var collectionFacetPromise = documents.search({
              q: this.query || "*",
              query_by: queryByField,
              filter_by: this._buildFilterBy("collection") || undefined,
              facet_by: this._facetField("collection"),
              max_facet_values: 30,
              per_page: 0,
            });
            var offerFacetPromise = documents.search({
              q: this.query || "*",
              query_by: queryByField,
              filter_by: this._buildFilterBy("offer_type") || undefined,
              facet_by: "offer_type",
              max_facet_values: 20,
              per_page: 0,
            });

            var priceFilterBy = this._buildFilterBy("price");
            var minPromise = documents.search({
              q: this.query || "*",
              query_by: queryByField,
              filter_by: priceFilterBy || undefined,
              sort_by: "price:asc",
              per_page: 1,
            });
            var maxPromise = documents.search({
              q: this.query || "*",
              query_by: queryByField,
              filter_by: priceFilterBy || undefined,
              sort_by: "price:desc",
              per_page: 1,
            });

            var all = await Promise.all([
              mainSearchPromise,
              vendorFacetPromise,
              collectionFacetPromise,
              offerFacetPromise,
              minPromise,
              maxPromise,
            ]);
            var results = all[0];
            var vendorFacetResult = all[1];
            var collectionFacetResult = all[2];
            var offerFacetResult = all[3];
            var minResult = all[4];
            var maxResult = all[5];

            if (minResult.hits && minResult.hits[0]) {
              this.priceBoundsMin = minResult.hits[0].document.price;
            }
            if (maxResult.hits && maxResult.hits[0]) {
              this.priceBoundsMax = maxResult.hits[0].document.price;
            }

            this.resultsCount = results.found || 0;
            this.hasMore = (results.page || 1) * (perPage || 24) < this.resultsCount;

            this._renderFacets({
              vendor:
                (vendorFacetResult.facet_counts &&
                  vendorFacetResult.facet_counts[0] &&
                  vendorFacetResult.facet_counts[0].counts) ||
                [],
              collection:
                (collectionFacetResult.facet_counts &&
                  collectionFacetResult.facet_counts[0] &&
                  collectionFacetResult.facet_counts[0].counts) ||
                [],
              offer_type:
                (offerFacetResult.facet_counts &&
                  offerFacetResult.facet_counts[0] &&
                  offerFacetResult.facet_counts[0].counts) ||
                [],
            });

            var html = (results.hits || []).map((hit) => this._renderProductCard(hit)).join("");
            if (appendPage) {
              this.productsHtml += html;
            } else {
              this.productsHtml = html;
            }

            this._updateUrl(!appendPage && this._userInitiated);
            this._userInitiated = false;

            this.$nextTick(() => {
              if (typeof initializeScrollAnimationTrigger === "function") initializeScrollAnimationTrigger();
              this._setupInfiniteScroll();
              this._syncFacetCheckboxes();
            });
          } catch (err) {
            console.error("Typesense search page error", err);
          } finally {
            this.isLoading = false;
            this.isLoadingMore = false;
          }
        },

        async loadMore() {
          if (this.isLoadingMore || !this.hasMore) return;
          this.page += 1;
          await this.runSearch(true);
        },

        _setupInfiniteScroll() {
          var sentinel = document.getElementById("SearchInfiniteScrollSentinel");
          if (!sentinel) return;
          if (this._observer) this._observer.disconnect();
          this._observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && this.hasMore && !this.isLoadingMore) {
                this.loadMore();
              }
            });
          });
          this._observer.observe(sentinel);
        },

        toggleFacetValue(group, value) {
          this._userInitiated = true;
          var list = this.selected[group];
          var idx = list.indexOf(value);
          if (idx === -1) {
            list.push(value);
          } else {
            list.splice(idx, 1);
          }
          this.runSearch(false);
        },

        setBooleanFacet(group, value) {
          this._userInitiated = true;
          this.selected[group] = this.selected[group] === value ? null : value;
          this.runSearch(false);
        },

        applyPriceRange(min, max) {
          this._userInitiated = true;
          this.priceMin = min;
          this.priceMax = max;
          this.runSearch(false);
        },

        rangePercent(value, fallback) {
          var v = value === null || value === undefined ? fallback : value;
          var range = this.priceBoundsMax - this.priceBoundsMin;
          if (!range) return 0;
          return Math.max(0, Math.min(100, ((v - this.priceBoundsMin) / range) * 100));
        },

        onRangeMinInput(evt) {
          var val = Number(evt.target.value);
          var maxVal = this.priceMax !== null ? this.priceMax : this.priceBoundsMax;
          if (val > maxVal) val = maxVal;
          this.priceMin = val;
        },

        onRangeMaxInput(evt) {
          var val = Number(evt.target.value);
          var minVal = this.priceMin !== null ? this.priceMin : this.priceBoundsMin;
          if (val < minVal) val = minVal;
          this.priceMax = val;
        },

        resetPriceFilter() {
          this._userInitiated = true;
          this.priceMin = null;
          this.priceMax = null;
          this.runSearch(false);
        },

        setSortBy(value) {
          this._userInitiated = true;
          this.sortBy = value;
          this.runSearch(false);
        },

        clearAllFilters() {
          this._userInitiated = true;
          this.selected.vendor = [];
          this.selected.collection = [];
          this.selected.offer_type = [];
          this.selected.tag = [];
          this.selected.available = null;
          this.selected.on_sale = null;
          this.selected.prescribed = null;
          this.priceMin = null;
          this.priceMax = null;
          this.$nextTick(() => this._syncFacetCheckboxes());
          this.runSearch(false);
        },

        removeFilterChip(group, value) {
          this._userInitiated = true;
          if (group === "price") {
            this.priceMin = null;
            this.priceMax = null;
          } else if (group === "available" || group === "on_sale" || group === "prescribed") {
            this.selected[group] = null;
          } else if (group === "tag") {
            var tagIdx = this.selected.tag.indexOf(value);
            if (tagIdx !== -1) this.selected.tag.splice(tagIdx, 1);
          } else {
            var list = this.selected[group];
            var idx = list.indexOf(value);
            if (idx !== -1) list.splice(idx, 1);
          }
          this.$nextTick(() => this._syncFacetCheckboxes());
          this.runSearch(false);
        },

        get activeFilterChips() {
          var chips = [];
          var self = this;
          this.selected.tag.forEach((v) => chips.push({ group: "tag", value: v, label: humanizeTagHandle(v) }));
          this.selected.vendor.forEach((v) => chips.push({ group: "vendor", value: v, label: v }));
          this.selected.collection.forEach((v) => chips.push({ group: "collection", value: v, label: v }));
          this.selected.offer_type.forEach((v) => chips.push({ group: "offer_type", value: v, label: v }));
          if (this.selected.available !== null) {
            chips.push({
              group: "available",
              value: this.selected.available,
              label: this.selected.available ? "In stock" : "Out of stock",
            });
          }
          if (this.selected.on_sale !== null) {
            chips.push({ group: "on_sale", value: this.selected.on_sale, label: "On sale" });
          }
          if (this.selected.prescribed !== null) {
            chips.push({
              group: "prescribed",
              value: this.selected.prescribed,
              label: this.selected.prescribed
                ? (self.isArabic ? " وصفة طبية" : "Prescribed")
                : (self.isArabic ? " بدون وصفة طبية" : "Not prescribed"),
            });
          }
          if (this.priceMin !== null || this.priceMax !== null) {
            chips.push({
              group: "price",
              value: null,
              label: formatMoney(this._cfg, this.priceMin || this.priceBoundsMin, self.currencyText) +
                " - " + formatMoney(this._cfg, this.priceMax || this.priceBoundsMax, self.currencyText),
            });
          }
          return chips;
        },

        toggleLayout(isList) {
          this.listLayout = isList;
          localStorage.setItem(FACET.productLayout, isList ? "list" : "grid");
        },

        visibleFacetItems(group) {
          var items = this.facetData[group] || [];
          if (this.expandedFacets[group] || items.length <= FACET_VISIBLE_LIMIT) return items;
          return items.slice(0, FACET_VISIBLE_LIMIT);
        },

        toggleFacetExpanded(group) {
          this.expandedFacets[group] = !this.expandedFacets[group];
        },

        isBogoOffer(value) {
          return isBogoOfferValue(value);
        },

        offerPillLabel(value) {
          return formatOfferPillLabel(value);
        },

        _syncFacetCheckboxes() {
          var boxes = document.querySelectorAll('input[type="checkbox"][data-facet-group]');
          var self = this;
          boxes.forEach(function (box) {
            var group = box.getAttribute("data-facet-group");
            if (group === "available") {
              box.checked = self.selected.available === true;
            } else if (group === "on_sale") {
              box.checked = self.selected.on_sale === true;
            } else if (group === "prescribed") {
              box.checked = self.selected.prescribed === true;
            } else if (self.selected[group]) {
              box.checked = self.selected[group].indexOf(box.getAttribute("data-facet-value")) !== -1;
            }
          });
        },

        _renderFacets(counts) {
          this.facetData.vendor = counts.vendor || [];
          this.facetData.collection = (counts.collection || []).filter(
            (item) => !isHiddenCollectionValue(item.value)
          );
          this.facetData.offer_type = (counts.offer_type || [])
            .slice()
            .sort((a, b) => offerDiscountWeight(b.value) - offerDiscountWeight(a.value));
        },

        _renderProductCard(hit) {
          var doc = hit.document;
          var cfg = this._cfg;
          var isArabic = this.isArabic;
          var currText = this.currencyText;
          var name = isArabic ? doc.name_ar : doc.name_en;
          var vendorName = isArabic ? doc.vendor_name_ar : doc.vendor_name_en;
          var url = localizedUrl("/products/" + encodeURIComponent(doc.handle), isArabic);
          var image = doc.image_url || DEFAULT_IMAGE;
          var nameEsc = escapeHtml(name);
          var urlEsc = escapeHtml(url);

          // Price: sale_price/on_sale takes priority (explicit sale price,
          // no mega sale badge), then compare_at_price (implied discount,
          // WITH the mega sale badge -- same split as ts-search.js's
          // renderProductPrice), then plain price with neither.
          var price = Number(doc.price || 0);
          var salePrice = Number(doc.sale_price || 0);
          var compareAtPrice = Number(doc.compare_at_price || 0);
          var onSale = doc.on_sale === true;

          var priceHtml;
          if (onSale && salePrice > 0 && salePrice < price) {
            priceHtml = renderPriceMarkupCard(cfg, salePrice, price, false, doc, isArabic, currText);
          } else if (compareAtPrice > price) {
            priceHtml = renderPriceMarkupCard(cfg, price, compareAtPrice, true, doc, isArabic, currText);
          } else {
            priceHtml =
              '<div class="product-card__price mb-3 h5 inline-block main-price">' +
              formatMoney(cfg, price, currText) +
              "</div>";
          }

          // Badge text: prefer a BOGO-formatted label derived from offer_type
          // ("1 + 1", "2 + 1"...) when the offer is BOGO-style, since
          // offer_badge for these often isn't pre-formatted the same way the
          // percentage badges are. Falls back to offer_badge (already
          // display-ready, e.g. "-50%") for everything else, then to a
          // formatted offer_type, then -- when none of those exist -- to a
          // percentage computed from compare_at_price (same fallback order
          // as ts-search.js's doc.offer_badge || computeCompareAtBadge(doc)).
          var badgeText = "";
          if (doc.offer_type && isBogoOfferValue(doc.offer_type)) {
            badgeText = formatOfferPillLabel(doc.offer_type);
          } else if (doc.offer_badge) {
            badgeText = doc.offer_badge;
          } else if (doc.offer_type) {
            badgeText = formatOfferPillLabel(doc.offer_type);
          } else {
            badgeText = computeCompareAtBadge(doc);
          }
          var badge = "";
          if (badgeText) {
            badge =
              '<div class="top-left-container label-container absolute flex gap-1 pointer-events-none top-1.5 flex-col left-1.5 right-1.5 text-left">' +
              '<div class="x-badge-sale-label x-badge-container pointer-events-none ltr" style="--rounded-corners: 4px;">' +
              '<div class="x-badge-content x-badge-text h7 px-2 py-1 text-left ltr select-none inline-flex justify-center items-center opacity-100 rounded-corners gap-2" ' +
              'style="font-size: var(--h7-font-size);background-color:#f2eb41;border-color:#f2eb41;color:#1d28aa">' +
              '<span class="leading-normal w-fit p-break-words">' + escapeHtml(badgeText) + "</span></div></div></div>";
          }

          var prescribed = doc.is_prescribed
            ? '<div class="ts-prescribed-badge" aria-label="Prescription required">PRESCRIBED</div>'
            : "";

          var vendorHtml = "";
          if (vendorName) {
            var vendorQueryName = doc.vendor_name_en || vendorName;
            var vendorUrl = localizedUrl("/collections/vendors?q=" + encodeURIComponent(vendorQueryName), isArabic);
            vendorHtml =
              '<a href="' + escapeHtml(vendorUrl) + '" class="product-card__vendor product-info__vendor mb-1 text-small color-text-[rgba(var(--color-text),0.6)] block hover:underline">' +
              escapeHtml(vendorName) + "</a>";
          }

          var productId = productIdFromGid(doc.gid);
          var quickViewHtml = "";
          if (productId) {
            var qvIcon = getIconHtml("TsIconQuickview");

            var cartIcon =
              '<svg width="100%" height="100%" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M25.8584 81.5792C25.8584 83.838 26.5538 86.0461 27.8567 87.9242C29.1597 89.8024 31.0115 91.2662 33.1782 92.1306C35.3449 92.995 37.729 93.2212 40.0291 92.7805C42.3293 92.3398 44.4421 91.2521 46.1004 89.6549C47.7587 88.0577 48.888 86.0227 49.3455 83.8073C49.803 81.5919 49.5682 79.2955 48.6707 77.2087C47.7733 75.1218 46.2535 73.3381 44.3035 72.0832C42.3536 70.8283 40.061 70.1584 37.7159 70.1584C34.5721 70.1616 31.5579 71.3658 29.3349 73.5069C27.1119 75.6481 25.8616 78.5512 25.8584 81.5792ZM42.2539 81.5792C42.2539 82.4437 41.9878 83.2888 41.4891 84.0075C40.9905 84.7263 40.2817 85.2866 39.4525 85.6174C38.6233 85.9482 37.7108 86.0348 36.8305 85.8661C35.9502 85.6975 35.1416 85.2812 34.507 84.6699C33.8723 84.0586 33.4401 83.2798 33.265 82.4319C33.0899 81.584 33.1798 80.7052 33.5233 79.9065C33.8667 79.1078 34.4484 78.4252 35.1947 77.9449C35.9409 77.4646 36.8183 77.2083 37.7159 77.2083C38.9152 77.2145 40.0632 77.6777 40.909 78.4968C41.7548 79.3158 42.2295 80.424 42.2295 81.5792H42.2539Z" fill="currentColor"/>' +
                '<path d="M75.9683 70.1584C73.6231 70.1584 71.3306 70.8283 69.3807 72.0832C67.4307 73.3381 65.9109 75.1218 65.0134 77.2087C64.116 79.2955 63.8812 81.5919 64.3387 83.8073C64.7962 86.0227 65.9255 88.0577 67.5838 89.6549C69.2421 91.2521 71.3549 92.3398 73.655 92.7805C75.9552 93.2212 78.3393 92.995 80.506 92.1306C82.6726 91.2662 84.5245 89.8024 85.8274 87.9242C87.1303 86.0461 87.8258 83.838 87.8258 81.5792C87.8225 78.5512 86.5722 75.6481 84.3492 73.5069C82.1262 71.3658 79.1121 70.1616 75.9683 70.1584ZM75.9683 85.9501C75.0708 85.9501 74.1934 85.6938 73.4471 85.2135C72.7008 84.7332 72.1192 84.0505 71.7757 83.2519C71.4322 82.4532 71.3424 81.5744 71.5175 80.7265C71.6926 79.8786 72.1248 79.0998 72.7594 78.4885C73.3941 77.8772 74.2027 77.4609 75.083 77.2923C75.9633 77.1236 76.8757 77.2102 77.7049 77.541C78.5342 77.8718 79.2429 78.4321 79.7415 79.1509C80.2402 79.8696 80.5064 80.7147 80.5064 81.5792C80.5031 82.7364 80.0236 83.8451 79.1729 84.6623C78.3222 85.4795 77.1698 85.9384 75.9683 85.9383V85.9501Z" fill="currentColor"/>' +
                '<path d="M7.65971 14.0498H21.0787L31.4234 63.8453C31.5897 64.6436 32.0378 65.3619 32.6916 65.8781C33.3454 66.3943 34.1646 66.6766 35.01 66.677H84.1599C84.9876 66.6758 85.7904 66.4045 86.4373 65.9073C87.0843 65.4101 87.5373 64.7163 87.722 63.9393L95.9075 29.7358C96.0303 29.2197 96.0308 28.6837 95.909 28.1675C95.7873 27.6513 95.5463 27.1681 95.2041 26.7539C94.8619 26.3396 94.4272 26.0049 93.9323 25.7746C93.4374 25.5443 92.8951 25.4243 92.3454 25.4236H56.2851C55.3887 25.4158 54.5205 25.7252 53.8453 26.2931L41.2559 36.8679C40.874 37.166 40.5584 37.5353 40.3279 37.9535C40.0974 38.3717 39.9568 38.8304 39.9144 39.3022C39.872 39.7739 39.9287 40.2491 40.0812 40.6992C40.2336 41.1494 40.4787 41.5653 40.8017 41.9223C41.1247 42.2792 41.5191 42.5698 41.9613 42.7767C42.4035 42.9836 42.8845 43.1026 43.3755 43.1265C43.8664 43.1504 44.3577 43.0789 44.819 42.916C45.2807 42.7532 45.7035 42.5024 46.0623 42.1787L57.6148 32.4735H87.7464L81.2687 59.6271H37.9743L27.5929 9.83169C27.4267 9.03334 26.9786 8.31505 26.3248 7.79885C25.671 7.28265 24.8518 7.00038 24.0064 7H7.65971C6.6891 7 5.75823 7.37138 5.07191 8.03243C4.38558 8.69348 4 9.59006 4 10.5249C4 11.4598 4.38558 12.3564 5.07191 13.0174C5.75823 13.6785 6.6891 14.0498 7.65971 14.0498Z" fill="currentColor"/>' +
              '</svg>';

            var spinnerIcon =
              '<svg class="animate-spin" width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>' +
                '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>' +
              '</svg>';

            /*
            * ============================================================
            * DESKTOP QUICK VIEW
            * ============================================================
            */

            /*'class="button-quick-view__product-card ' +
                'hidden md:flex w-9 h-9 rounded-full p-2 items-center justify-center ' +
                'button-secondary absolute top-2 ' +
                (isArabic ? 'left-2' : 'right-2') +
                ' z-20" ' +*/
            var desktopQuickViewHtml =
            '<div class="product-card__widget hidden md:flex flex-col gap-1 h-fit absolute w-fit ' +
              (isArabic ? 'left-0' : 'right-0') +
              ' top-auto bottom-0 md:top-0 md:bottom-auto p-1.5 z-20">' +

              '<div class="product-card__widget-quick-view product-card__widget-item">' +

                '<button type="button" ' +
                  'class="button-quick-view__product-card ' +
                  'w-[34px] h-[34px] md:w-9 md:h-9 rounded-full p-[9px] ' +
                  'flex items-center justify-center button-secondary" ' +
                  'aria-label="Quick view" ' +
                  "onclick=\"(function(btn){ " +
                    "var qv = window.Alpine && Alpine.store('xQuickView'); " +
                    "if (qv && qv.enabled) { " +
                      "qv.load('" + jsStringEscape(productId) + "', '" +
                      jsStringEscape(url) + "', btn) && qv.open(); " +
                    "} " +
                  "})(this)\">" +

                  qvIcon +

                '</button>' +

              '</div>' +

            '</div>';

            /*
            * ============================================================
            * MOBILE QUICK VIEW + ADD TO CART
            * ============================================================
            */
            var mobileQuickViewHtml =
              '<div class="product-card__widget ts-mobile-actions ' +
                'flex flex-col gap-2 h-fit absolute w-fit bottom-2 right-2 p-0 z-20 md:hidden">' +

                // MOBILE QUICK VIEW
                '<button type="button" ' +
                  'class="button-quick-view__product-card ' +
                  'w-9 h-9 rounded-full p-2 flex items-center justify-center ' +
                  'button-secondary ts-mobile-action-button" ' +
                  'aria-label="Quick view" ' +
                  "onclick=\"(function(btn){ " +
                    "var qv = window.Alpine && Alpine.store('xQuickView'); " +
                    "if (qv && qv.enabled) { " +
                      "qv.load('" + jsStringEscape(productId) + "', '" +
                      jsStringEscape(url) + "', btn) && qv.open(); " +
                    "} " +
                  "})(this)\">" +
                  qvIcon +
                '</button>' +

                // MOBILE ADD TO CART
                (doc.available && doc.variant_id
                  ? '<button type="button" ' +
                      'class="ts-mobile-add-to-cart ' +
                      'w-9 h-9 rounded-full p-2 flex items-center justify-center ' +
                      'button-primary ts-mobile-action-button" ' +
                      'aria-label="' + (isArabic ? "أضف إلى السلة" : "Add to cart") + '" ' +
                      'data-cart-icon=\'' + cartIcon.replace(/'/g, "&#39;") + '\' ' +
                      'data-spinner-icon=\'' + spinnerIcon.replace(/'/g, "&#39;") + '\' ' +
                      'onclick="' +
                        "event.preventDefault();" +
                        "event.stopPropagation();" +

                        // Prevent double click
                        "var btn = this;" +
                        "if(btn.disabled)return;" +
                        "btn.disabled = true;" +

                        // Save original icon
                        "var originalHTML = btn.innerHTML;" +

                        // Show spinner
                        "btn.innerHTML = btn.getAttribute('data-spinner-icon');" +

                        // Add to cart
                        "fetch('/cart/add.js',{method:'POST'," +
                          "headers:{'Content-Type':'application/json'}," +
                          "body:JSON.stringify({id:" + Number(doc.variant_id) + ",quantity:1})" +
                        "})" +

                        ".then(function(r){" +
                          "if(!r.ok)throw new Error('Add to cart failed');" +
                          "return r.json();" +
                        "})" +

                        ".then(function(){" +
                          "document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));" +
                        "})" +

                        ".catch(function(e){" +
                          "console.error(e);" +
                        "})" +

                        ".finally(function(){" +
                          "btn.innerHTML = originalHTML;" +
                          "btn.disabled = false;" +
                        "});" +
                      '">' +
                      cartIcon +
                    '</button>'
                  : '') +

              '</div>';

            /*
            * Combine desktop + mobile Quick View
            */
            quickViewHtml = desktopQuickViewHtml + mobileQuickViewHtml;
          }


          var addToCart;

          //var txtAdd = isArabic ? "أضف إلى السلة" : "Add to cart";
          var txtAdd = isArabic ? "أضف" : "Add";
          var txtAdded = isArabic ? "تمت الإضافة" : "Added!";
          var txtSold = isArabic ? "غير متوفر حاليا" : "Sold out";
          var txtQtyLabel = isArabic ? "الكمية" : "Quantity";
          var txtDecrease = isArabic ? "إنقاص" : "Decrease quantity";
          var txtIncrease = isArabic ? "زيادة" : "Increase quantity";


          if (doc.available && doc.variant_id) {

            addToCart =
              '<div class="w-full hidden md:flex items-stretch gap-2' +
                (isArabic ? ' rtl:flex-row-reverse' : '') +
                '" style="margin-top:auto;" x-data="{ qty: 1, state: \'idle\' }">' +

                /*
                * ============================================================
                * DESKTOP QUANTITY
                * ============================================================
                */
                '<div class="w-[60%] hidden md:block">' +
                  '<div class="product-card__quantity-wrapper">' +
                    '<div class="flex flex-col gap-1.5 h-full">' +
                      '<div class="w-full h-full lg:w-full flex">' +

                        '<div class="flex color-text-[rgba(var(--color-heading),0.8)] ' +
                          'w-fit items-center border color-border-[rgba(var(--color-text),0.2)] ' +
                          'rounded-md w-full flex justify-between">' +

                          /*
                          * DECREASE
                          */
                          '<div class="flex justify-center items-center bg-transparent select-none px-3 py-[15px]" ' +
                            ':class="qty <= 1 ? \'cursor-not-allowed opacity-50 pointer-events-none\' : \'cursor-pointer\'" ' +
                            '@click.prevent="if (qty > 1) qty = qty - 1" ' +
                            'tabindex="0" role="button" aria-label="' + txtDecrease + '">' +

                            '<span class="w-3 h-3 flex color-text-[rgba(var(--color-text))]">' +
                              '<svg xmlns="http://www.w3.org/2000/svg" ' +
                                'aria-hidden="true" focusable="false" role="presentation" ' +
                                'fill="none" viewBox="0 0 10 2">' +
                                '<path fill-rule="evenodd" clip-rule="evenodd" ' +
                                  'd="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" ' +
                                  'fill="currentColor"></path>' +
                              '</svg>' +
                            '</span>' +
                          '</div>' +

                          /*
                          * QUANTITY INPUT
                          */
                          '<input class="outer-spin-button color-text-[rgba(var(--color-text))] ' +
                            'focus:outline-none text-medium text-center bg-transparent ' +
                            'rounded-corners py-2.5 md:py-2.5 w-8" ' +
                            'type="number" min="1" x-model.number="qty" ' +
                            '@blur="if (!qty || qty < 1) qty = 1" ' +
                            'aria-label="' + txtQtyLabel + '">' +

                          /*
                          * INCREASE
                          */
                          '<div class="flex justify-center items-center cursor-pointer ' +
                            'bg-transparent select-none px-3 py-[15px]" ' +
                            '@click.prevent="qty = qty + 1" ' +
                            'tabindex="0" role="button" aria-label="' + txtIncrease + '">' +

                            '<span class="flex h-3 w-3 color-text-[rgba(var(--color-text))]">' +
                              '<svg xmlns="http://www.w3.org/2000/svg" ' +
                                'aria-hidden="true" focusable="false" role="presentation" ' +
                                'fill="none" viewBox="0 0 10 10">' +
                                '<path fill-rule="evenodd" clip-rule="evenodd" ' +
                                  'd="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" ' +
                                  'fill="currentColor"></path>' +
                              '</svg>' +
                            '</span>' +
                          '</div>' +

                        '</div>' +
                      '</div>' +
                    '</div>' +
                  '</div>' +
                '</div>' +

                /*
                * ============================================================
                * DESKTOP ADD TO CART BUTTON
                * ============================================================
                */
                '<div class="w-[40%]">' +

                  '<button class="product-form__btn-add-to-cart ' +
                    'button button-primary button-large relative h-fit rounded-corners-md ' +
                    'py-3 w-full min-h-[44px] h-full px-3" ' +

                    'type="button" ' +

                    ':disabled="state === \'loading\'" ' +

                    ':class="state === \'loading\' && \'opacity-70 pointer-events-none\'" ' +

                    "@click=\"state = 'loading'; " +

                    "fetch('/cart/add.js', {" +
                      "method:'POST', " +
                      "headers:{'Content-Type':'application/json'}, " +
                      "body: JSON.stringify({id: " + Number(doc.variant_id) + ", quantity: qty})" +
                    "})" +

                    ".then(function(r){return r.json();})" +

                    ".then(function(){ " +
                      "state = 'added'; " +
                      "document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true})); " +
                      "setTimeout(function(){ state = 'idle'; }, 1500); " +
                    "})" +

                    ".catch(function(){ " +
                      "state = 'idle'; " +
                    "});\">" +

                    '<span class="btn__text" ' +
                      'x-text="state === \'added\' ? \'' + txtAdded + '\' : \'' + txtAdd + '\'">' +
                      txtAdd +
                    '</span>' +

                    /*
                    * DESKTOP LOADING SPINNER
                    */
                    '<span class="inline-block w-5 h-5 animate-spin ' +
                      'absolute left-[calc(50%-10px)] top-[calc(50%-10px)]" ' +
                      'x-show="state === \'loading\'" style="display: none;">' +

                      '<svg version="1.0" xmlns="http://www.w3.org/2000/svg" ' +
                        'viewBox="0 0 512.000000 512.000000" ' +
                        'preserveAspectRatio="xMidYMid meet">' +

                        '<g transform="translate(0.000000,512.000000) ' +
                          'scale(0.100000,-0.100000)" ' +
                          'fill="currentColor" stroke="none">' +

                          '<path d="M2474 4676 c-43 -19 -101 -81 -115 -123 -18 -56 -7 -145 24 -190 52 -75 79 -85 262 -99 90 -7 207 -22 260 -33 436 -92 824 -352 1070 -721 521 -781 321 -1824 -453 -2358 -501 -345 -1172 -393 -1715 -121 -700 350 -1075 1118 -917 1876 37 180 86 305 209 536 51 96 54 147 15 226 -37 73 -86 104 -174 109 -105 6 -151 -24 -224 -145 -137 -230 -241 -543 -276 -833 -13 -110 -13 -355 1 -478 52 -475 268 -922 614 -1267 351 -352 787 -560 1284 -615 171 -19 442 -8 615 24 423 80 802 282 1111 591 407 407 625 931 625 1505 0 574 -218 1098 -625 1505 -296 296 -654 493 -1055 579 -210 45 -470 61 -536 32z"></path>' +

                        '</g>' +
                      '</svg>' +

                    '</span>' +

                  '</button>' +

                '</div>' +

              '</div>';

          } else {

            addToCart =
              '<a href="' + urlEsc + '" ' +
                'class="btn btn--secondary w-full text-small py-2 px-3 ' +
                'rounded-corners-sm text-center opacity-60" ' +
                'style="margin-top:auto;">' +
                txtSold +
              '</a>';
          }

          return (
            '<div class="grid-item">' +
            '<div class="product-card__wrapper color-scheme-theme anm-reveal-item rounded-corners text-left h-full overflow-hidden flex flex-col gap-2 relative border border-solid p-2">' +
            '<div class="product-card__image-container w-full">' +
            '<div class="product-card__image-wrapper rounded-corners overflow-hidden w-full relative" style="padding-bottom:100%">' +
            '<a href="' + urlEsc + '" aria-label="' + nameEsc + '" class="link-product-variant rounded-corners w-full absolute top-0 left-0 bottom-0" tabindex="-1">' +
            '<div class="slide-item h-full is-active">' +
            '<img class="product-card__image w-full is-active object-cover h-full" src="' + escapeHtml(image) +
            '" alt="' + nameEsc + '" width="400" height="400" loading="lazy">' +
            "</div>" +
            "</a>" +
            badge +
            prescribed +
            quickViewHtml +
            "</div>" +
            "</div>" +
            '<div class="below-image ltr flex flex-wrap gap-1 empty:hidden"></div>' +
            '<div class="product-card__info-wrapper overflow-hidden ltr flex flex-col w-full relative text-left" style="flex:1;display:flex;">' +
            '<div class="product-card__info flex flex-col h-full" style="flex:1;">' +
            vendorHtml +
            '<div class="product-card__title h5 md:h6 mb-1">' +
            '<a class="link-product-variant touch-element inline-flex title-link p-break-words" href="' + urlEsc + '" aria-label="' + nameEsc + '">' +
            nameEsc + "</a></div>" +
            priceHtml +
            addToCart +
            "</div></div></div></div>"
          );
        },
      };
    });
  });
})();